import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Don't trigger in inputs
      const tag = (e.target as HTMLElement).tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return;

      // Esc — close settings/journal → back to chat
      if (e.key === "Escape") {
        if (location.pathname === "/settings" || location.pathname === "/journal") {
          e.preventDefault();
          navigate("/chat");
        }
        return;
      }

      // Ctrl/Cmd shortcuts
      if (e.ctrlKey || e.metaKey) {
        if (e.key === ",") {
          e.preventDefault();
          navigate("/settings");
        } else if (e.key === "j" || e.key === "J") {
          e.preventDefault();
          navigate("/journal");
        } else if (e.key === "k" || e.key === "K") {
          e.preventDefault();
          // Focus chat input
          const input = document.querySelector("textarea") as HTMLTextAreaElement;
          input?.focus();
        }
      }

      // "/" to focus chat input (only on chat page)
      if (e.key === "/" && location.pathname === "/chat") {
        e.preventDefault();
        const input = document.querySelector("textarea") as HTMLTextAreaElement;
        input?.focus();
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [navigate, location.pathname]);
}
